import React from 'react';
import { useFocusOnShow } from '../hooks';

interface Props {
  title: string;
  text: string;
  confirmLabel: string;
  cancelLabel: string;
  onConfirm: () => void;
  onCancel: () => void;
  busy?: boolean;
  danger?: boolean;
}

/** Встроенное подтверждение: последствие названо словами до действия (вместо окна Modal). */
export const ConfirmPanel: React.FC<Props> = ({
  title, text, confirmLabel, cancelLabel, onConfirm, onCancel, busy = false, danger = false,
}) => {
  // Кнопка, открывшая панель, исчезла или далеко: фокус уходит на заголовок панели (его же браузер и прокрутит в поле зрения).
  const heading = useFocusOnShow<HTMLHeadingElement>();
  return (
    <div className={`tw-panel tw-stack-sm${danger ? ' tw-panel-danger' : ''}`}>
      <h3 ref={heading} tabIndex={-1}>{title}</h3>
      <p className="tw-help">{text}</p>
      <div className="tw-row tw-btn-row">
        <button type="button" className={`tw-btn ${danger ? 'tw-btn-danger' : 'tw-btn-primary'}`} disabled={busy} onClick={onConfirm}>{confirmLabel}</button>
        <button type="button" className="tw-btn" disabled={busy} onClick={onCancel}>{cancelLabel}</button>
      </div>
    </div>
  );
};
